import type { ComponentType } from 'preact'
import type { Store } from '../net/store'
import { useChunk } from '../ui/useChunk'
import { useStore } from '../ui/useStore'
import type * as DialogChunk from './NameDialog'
import type { ProfileStore } from './profileStore'

const cache: { m: typeof DialogChunk | null } = { m: null }
const load = () => import('./NameDialog')

/**
 * `session.NameDialog` (T2.6): mounted once by `App`; renders nothing until `session.rename()`
 * opens it, so the picker's code loads only then.
 */
export function makeLazyNameDialog(open: Store<boolean>, profile: ProfileStore): ComponentType {
  return function NameDialog() {
    const isOpen = useStore(open)
    const mod = useChunk(isOpen, load, cache)
    return isOpen && mod ? <mod.NameDialogView open={open} profile={profile} /> : null
  }
}
